import { fulfilled } from '../reducers/utils/asyncActionNameSuffixes';

export const FETCH_CONFIG = 'FETCH_CONFIG';

export function fetchConfig(params) {
  return {
    type: FETCH_CONFIG,
    api: {
      endpoint: ['config', 'get'],
      args: [params],
    },
  };
}

/**
 * Seeds the store with config fetched before the store existed, in the shape the api middleware
 * gives a fulfilled `fetchConfig` on the server.
 */
export function receiveConfig(config) {
  return {
    type: fulfilled(FETCH_CONFIG),
    payload: { ...config, loadedTime: null },
  };
}
